// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { entityTypeApi as EntityTypeApi } from "../../Constant";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

export const entityTypeApi = createApi({
  reducerPath: "entityType",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["EntityType"],
  endpoints: (builder) => ({
    getEntityTypeList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["EntityType"],
    }),

    getSingleEntityType: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
   
   
    getEntitySubCategory: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    

    deleteEntity: builder.mutation({
      query: (endpoint) => ({
        url: `${endpoint}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EntityType"],
    }),

    addEntityType: builder.mutation({
      query: ({ endpoint, newEntityType }) => ({
        url: endpoint,
        method: "POST",
        body: newEntityType,
      }),
      invalidatesTags: ["EntityType"],
    }),
    addEntity: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EntityType"],
    }),

    updateEntity: builder.mutation({
      query: ({ endpoint, updateEntityType }) => ({
        url: endpoint,
        method: "PATCH",
        body: JSON.stringify(updateEntityType),
      }),
      invalidatesTags: ["EntityType"],
    }),
   
    statusEntityType: builder.mutation({
      query: ({ isPublished, id }) => {
        return {
          url: `${EntityTypeApi.endPoint}/status/${id}`,
          method: 'PATCH',
          body: {
            isPublished
          },
        };
      },
    }),

  }),
});

export const {
  useGetSingleEntityTypeQuery,
  useDeleteEntityTypeMutation,
  useAddEntityTypeMutation,
 useUpdateEntityMutation,
  useGetEntityTypeListQuery,
  useGetEntitySubCategoryQuery,
  useAddEntityMutation,
  useStatusEntityTypeMutation
} = entityTypeApi;
